<template>
    <div>
    <!-- 详情 --> 
    <a-drawer
            width="550px"
            :height="340"
            :visible="detailVisible"
            placement="right"
            :footer="false"
            @cancel="handleCancel"
            unmountOnClose
    >
        <template #title>
            <div style="font-weight:bold">{{ detail.order_name }} <span v-if="detail.prepaid_flag == 1">| {{ detail.prepaidCustomer }}</span></div>
        </template>
        <a-spin :loading="loading" tip="Loading...">
            <div>
                 <!-- 基础信息 -->
                 <a-divider orientation="left" style="font-weight:600"><icon-star /> {{ $t('base.moreInfo') }}</a-divider>
                <div class="detailItemParent">
                    <div class="detailItem_left">
                        <div class="detailItem">
                            <span class="fieldName"><a-badge status="processing" :text="$t('order.customerErpCode')" /></span> 
                            <span class="fieldValue">{{detail.customer_erp_code}}</span> 
                        </div>
                        <div class="detailItem">
                            <span class="fieldName"><a-badge status="processing" :text="$t('order.orderUse')" /></span> 
                            <span class="fieldValue">{{detail.order_use}}</span> 
                        </div>
                        <div class="detailItem">
                            <span class="fieldName"><a-badge status="processing" :text="$t('order.backFlag')" /></span> 
                            <span class="fieldValue">{{detail.back_flag}}</span> 
                        </div>
                        <div class="detailItem">
                            <span class="fieldName"><a-badge status="processing" :text="$t('order.userNote')" /></span> 
                            <span class="fieldValue">{{detail.user_note}}</span> 
                        </div>
                        <div class="detailItem">
                            <span class="fieldName"><a-badge status="processing" :text="$t('order.earliestShipTimestamp')" /></span> 
                            <span class="fieldValue">{{detail.earliest_ship_timestamp}}</span> 
                        </div>
                        <div class="detailItem">
                            <span class="fieldName"><a-badge status="processing" :text="$t('order.createUser')" /></span> 
                            <span class="fieldValue">{{detail.create_user}}</span> 
                        </div>
                        <div class="detailItem">
                            <span class="fieldName"><a-badge status="processing" :text="$t('order.createDate')" /></span> 
                            <span class="fieldValue">{{detail.create_date}}</span> 
                        </div>
                        <div class="detailItem">
                            <span class="fieldName"><a-badge status="processing" :text="$t('order.orderConfirmMail')" /></span> 
                            <span class="fieldValue">{{detail.order_confirm_mail}}</span> 
                        </div>
                        <div class="detailItem">
                            <span class="fieldName"><a-badge status="processing" :text="$t('order.secondHandFlag')" /></span> 
                            <span class="fieldValue">{{detail.second_hand_flag == 1 ? $t('base.YES') : $t('base.NO')}}</span> 
                        </div>
                        <div class="detailItem">
                            <span class="fieldName"><a-badge status="processing" :text="$t('order.orderCategory')" /></span> 
                            <span class="fieldValue">{{detail.order_category == 1 ? $t('dealerOpenOrder.bike') : detail.order_category == 2 ? $t('dealerOpenOrder.parts') : $t('dealerOpenOrder.normal')}}</span> 
                        </div>
                    </div>
                    <div class="detailItem_right">
                        
                    </div>
                </div>
            </div>
        </a-spin>
    </a-drawer>
    </div>
</template>

<script setup>
    import { nextTick, onMounted, reactive, ref, watch, toRefs, h } from 'vue';
    import { StockOutApi } from '@/api/StockOutApi.js';
    import { OrderApi } from '@/api/OrderApi.js';
    import { Message, Modal } from '@arco-design/web-vue';
    import Table from '@/components/Table.vue';
    import { dateToTimestamp, timestampToDate, getNowDate } from '@/utils/index.js';
    import { useI18n } from 'vue-i18n';


    const props = defineProps({
        row:{
            type:Object,
            default:()=>{}
        },
        detailVisible:{
            type:Boolean,
            default:false,
        },
    })

    const emits = defineEmits(['handleCancel'])

    const { t } = useI18n()

    const loading = ref(true)
    const title = ref('')
    const detail = ref({})

    const init = ()=>{
        title.value = t('base.moreInfo')
        
        for(let key in props.row){
            props.row[key] = props.row[key] == '' || props.row[key] == undefined? '-' : props.row[key]
        }
        props.row.prepaidCustomer = props.row.prepaid_flag == undefined? '' : props.row.prepaid_flag == 1? t('order.prepaidCustomer') : ''
        props.row.order_confirm_mail = props.row.order_confirm_mail == undefined? '' : props.row.order_confirm_mail
        console.log(props.row,'rowData')
        detail.value = props.row
        loading.value = false
    }

    const handleCancel = ()=>{
        emits('handleCancel')
    }


    watch(()=>props.detailVisible,async (val)=>{
        init()
    })

    onMounted(()=>{
        
    })
</script>

<style lang="less" scoped>
.detailItem{
    padding-left: 30px;
    line-height: 30px;
    white-space: nowrap;
    display: flex;
    align-items: center;
    
    .fieldName{
        display: inline-block;
        width: 190px;
        color: #333;
    }
    .fieldValue{
        display: inline-block;
        color: #888;
        flex: 1;
    }
}

.detailItemParent{
    display: flex;
    width: 100%;
    padding: 5px 0 20px;
    .detailItem_left,
    .detailItem_right{
        display: flex;
        flex: 1;
        flex-direction: column;
        padding-right: 100px;
    }
}

/deep/ .arco-divider-text{
    font-weight: bold;
}
</style>